import {useOutlet} from "react-router-dom";
import {defaultUser, useAuth} from "hooks/useAuth";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import {replaceDevUrl} from "utils/functions";
import React, {useEffect} from "react";
import Sidebar from "../sidebar/Sidebar";
import Container from "@mui/material/Container";

const LayoutUnverified = () => {
    const {update, user} = useAuth();
    const outlet = useOutlet();

    useEffect(() => {
        update("user", {theme: user.theme}, true);
        update("cart", defaultUser.cart);
        update("tenant", defaultUser.tenant);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Box component="main" display="flex" alignItems="stretch" sx={{minHeight: "100dvh", padding: {md: "40px"}}}>
            <Grid
                // display="grid"
                container
                direction="row"
                spacing={0}
                sx={(theme) => ({
                    borderRadius: {xs: 0, lg: theme.spacing(4, 4, 3, 3)},
                    background: "rgba(0, 40, 155, 0.4) no-repeat center",
                    backgroundImage: `url(${replaceDevUrl("/images/brio-background.jpg")})`,
                    backgroundSize: "cover",
                    backgroundBlendMode: "soft-light",
                    position: "relative",
                })}
            >
                <Grid
                    item
                    xs={12}
                    position="relative"
                    sx={(theme) => ({
                        padding: 0,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        borderRadius: 3,
                        margin: 0,
                    })}
                >
                    <Sidebar layoutPublic={true} />
                </Grid>
                <Grid
                    item
                    xs={12}
                    sx={(theme) => ({
                        border: "none",
                        borderRadius: theme.spacing(0, 0, 3, 3),
                    })}
                >
                    <Box
                        display="flex"
                        flexDirection="column"
                        justifyContent="center"
                        alignContent="center"
                        width="100%"
                        minHeight="calc(100dvh - 180px)"
                        sx={(theme) => ({
                            padding: {
                                xs: theme.spacing(3, 0, 3, 0),
                                lg: theme.spacing(5, 1, 5, 1)
                            }
                        })}
                    > <Container maxWidth="xl">{outlet}</Container>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default LayoutUnverified;
